import api from "../../services/api";
import { gmapApi } from "vue2-google-maps";
import moment from "moment";
import formatcoords from "formatcoords";
import helpers from "../../shared/fleetbox-helpers";
import { Marker, GeoPosition } from "../../domain/poi";
import { bus } from "../../main";
import marker from "vue2-google-maps/dist/components/marker";
import mapPoiCategoriesFilter from "../../components/map/poicategories.vue";
import trafficLayer from "../../components/map/viewtraffic.vue";
import { mapGetters } from "vuex";

export default {
	components: {
		mapPoiCategoriesFilter,
		trafficLayer
	},
	props: {
		data: Array,
		vehicleIdFilterFieldFormatted: String,
		mapCenterLocation: {
			type: Object,
			default: {
				lat: 0,
				lng: 0
			}
		},
		zoom: {
			type: Number,
			default: 12
		}
	},
	data: function() {
		return {
			firstTimeIn: true,
			center: {},
			markers: [],
			infoContent: "",
			infoWindowPos: null,
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				content: "",
				pixelOffset: {
					width: 0,
					height: -35
				}
			},

			markersShown: [],
			historyBounds: null,

			//POI
			poiAreas: [],
			poiPaths: [],
			poiMarkers: [],

			viewSatellite: false,
			mapStylesOptions: [ 
				{
					featureType: "poi",
					stylers: [ 
						{ 
							visibility: "off" 
						} 
					] 
				} 
			],
			showTitle: false
		};
	},
	watch: {},
	created() {
		var self = this;

		if (this.settings) {
			if (this.settings.viewSatellite) this.viewSatellite = this.settings.viewSatellite;
		}

		self.center = {
			lat: self.mapCenterLocation.lat,
			lng: self.mapCenterLocation.lng
		};

		self.$gmapApiPromiseLazy().then(() => {
			self.$watch("data", function(newValue, oldValue) {
				if (self.markersShown && self.markersShown.length > 0 && newValue) {
					//remove markers if needed
					let markersToRemove = self._.differenceBy(self.markersShown, newValue, "id");
					self.removeMarkers(markersToRemove);
				}

				if (newValue.length != self.markersShown.length) self.displayMarkers();
				self.markersShown = self._.clone(newValue);
			});
		});

		bus.$on("on-alarms-selected-row", self.onSelectedRow.bind(self));
		bus.$on("poi-category-filter-change", self.onPoiCategoryFilterChange.bind(self));
	},
	mounted() {
		var self = this;
		/* poi categories */
		if (this.settings && this.settings.viewPoi) {
			this.$nextTick(() => {
				self.$refs.alarmmap.$gmapApiPromiseLazy().then(res => {
					self.$refs.poiCatgeoriesFilter.loadControls(self.$refs.alarmmap);
				});
				//}, 1000);
			});
		}
		/* poi categories */

		/* traffic Layer */
		if (this.settings && this.settings.viewTraffic) {
			self.$refs.alarmmap.$gmapApiPromiseLazy().then(res => {
				self.$refs.alarmmap.$mapPromise.then(map => {
					var trafficLayer = new google.maps.TrafficLayer();
					self.$refs.trafficLayer.loadControls(self.$refs.alarmmap);
				});
			});
		}
		/* traffic Layer */
	},
	beforeDestroy() {
		var self = this;
		bus.$off("on-alarms-selected-row");
		bus.$off("poi-category-filter-change", self.onPoiCategoryFilterChange.bind(self));
	},
	/* metodi */
	methods: {
		markerOut() {
			helpers.deleteTooltip();
		},
		markerOver($event, m) {
			helpers.injectTooltip($event.tb, m.description);
		},
		displayPois: function(data) {
			var self = this;

			//items to remove - marker
			var itemsToRemove = [];
			for (let i = 0; i < this.poiMarkers.length; i++) {
				var m = this.poiMarkers[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiMarkers.findIndex(function(o) {
					return o.id == r;
				});

				self.poiMarkers.splice(index, 1);
			});

			//items to remove - polygon
			itemsToRemove = [];
			for (let i = 0; i < this.poiPaths.length; i++) {
				var m = this.poiPaths[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiPaths.findIndex(function(o) {
					return o.id == r;
				});

				self.poiPaths.splice(index, 1);
			});

			//items to remove - area
			itemsToRemove = [];
			for (let i = 0; i < this.poiAreas.length; i++) {
				var m = this.poiAreas[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiAreas.findIndex(function(o) {
					return o.id == r;
				});

				self.poiAreas.splice(index, 1);
			});

			data.forEach(function(item) {
				if (item.location.rendering_type == "marker" || (item.location.rendering_type == "unknown" && item.location.points.length == 1)) {
					let m = _.find(self.poiMarkers, function(o) {
						return o.id == item.id;
					});

					if (m == null) {
						m = new google.maps.Marker();
						m.id = item.id;
						m.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};

						self.poiMarkers.push(m);
					}

					m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					m.description = item.name;
					m.info = `<b>${item.name}</b><br />
								LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
								INDIRIZZO: ${item.location.address}<br />`;

					if (item.poi_category_icon_image) {
						var icon = {
							url: item.poi_category_icon_image,
							scaledSize: new google.maps.Size(30, 36), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						m.icon = icon;
					}
					m.infoWindowOptions.content = m.info;
				} else if (item.location.rendering_type == "polygon" || (item.location.rendering_type == "unknown" && item.location.points.length > 1)) {
					//marker related to polygon
					if (!self.isInEditMode) {
						let m = _.find(self.poiMarkers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.poiMarkers.push(m);
						}

						m.draggable = false;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.description = item.name;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}

					//polygon
					let p = _.find(self.poiPaths, function(o) {
						return o.id == item.id;
					});

					if (p == null) {
						p = {
							id: item.id,
							path: item.location.points.map(function(pt) {
								return new GeoPosition(pt.lat, pt.lon);
							}),
							infoWindowOptions: {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: 0
								}
							}
						};

						self.poiPaths.push(p);
					}

					p.fillColor = item.poi_category_fill_color;
					p.description = item.name;
					p.info = `<b>${item.name}</b><br />
									LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									INDIRIZZO: ${item.location.address}<br />`;
					p.infoWindowOptions.content = p.info;
				} else if (item.location.rendering_type == "circle") {
					//marker related to circle
					if (!self.isInEditMode) {
						let m = _.find(self.poiMarkers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.poiMarkers.push(m);
						}

						m.draggable = item.draggable;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.description = item.name;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}
					//area
					let a = _.find(self.poiAreas, function(o) {
						return o.id == item.id;
					});

					if (a == null) {
						a = new google.maps.Circle();
						a.id = item.id;
						a.radius = item.radius;
						a.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: 0
							}
						};

						self.poiAreas.push(a);
					}
					a.center = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					a.fillColor = item.poi_category_fill_color;
					a.description = item.name;
					a.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
					a.infoWindowOptions.content = a.info;
				}
			});
		},
		poiMarkerClick: function(marker) {
			helpers.deleteTooltip();
			this.hideAllInfoWindow();
			this.toggleInfoWindow(marker);
		},
		onPoiCategoryFilterChange(items) {
			this.displayPois(items);
		},
		onSelectedRow(e) {
			var self = this;
			if (e) {
				var self = this;
				var position = {
					lat: e.position.lat,
					lng: e.position.lon
				};
				this.centerMap(position);
				this.setCustomZoom(13);

				self.hideAllInfoWindow();
				self.markers.forEach(function(item, index) {
					item.zIndex = 0;
					if (item.id == e.id) {
						item.zIndex = 1;
						item.infoWindowOptions.infoWindowOpened = true;
					}
				});
			}
		},
		removeMarkers: function(markersToRemove) {
			var self = this;
			if (markersToRemove && markersToRemove.length > 0) {
				var idsToRemove = markersToRemove.map(function(x) {
					return x.id;
				});

				for (let i = 0; i < idsToRemove.length; i++) {
					let id = idsToRemove[i];
					let index = self.markers.findIndex(function(a) {
						return a.id == id;
					});

					if (index >= 0) {
						self.markers.splice(index, 1);
					}
					// self._.remove(self.markers, function(item) {
					// 	return item.id == id;
					// });
				}

				if (self.markers.length === 0) {
					self.markers = [];
				}
			}
		},
		displayMarkers: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.zIndex = 0;
			});

			self.hideAllInfoWindow();

			self.data.forEach(function(item, index) {
				let m = _.find(self.markers, function(o) {
					return o.id == item.id;
				});

				if (m == null) {
					m = new Marker();
					m.id = item.id;
					m.infoWindowOptions = {
						infoWindowOpened: false,
						pixelOffset: {
							width: 0,
							height: -40
						},
						indexLoopSamePosition: 0
					};

					self.markers.push(m);

					m.position = new GeoPosition(item.position.lat, item.position.lon);
					m.description = item.description;
					m.zIndex = 0;
					m.info = `<b class="header">${item.vehicle_name ? item.vehicle_name : "---"} - ${item[self.vehicleIdFilterFieldFormatted]}</b><br/>
						  <b class="driver">Conducente: ${item.driver_name ? item.driver_name : "---"}</b><br/><br/>
						  <span class="blackColor">${item.description}</span><br/>
						  ${item.severity_description ? `<span class="blackColor">${item.severity_description}</span><br/>` : ""}
						  <span class="lightGrey">${self.$options.filters.dateToString(item.event_date)} - ${self.$options.filters.timeToString(item.event_date)}</span><br/><br/>
						  ${
								item.data && item.data.alarmType
									? '<span class="gray-color">Tipo:</span> <span class="lightGrey">' +
									  (self.settings.commonLabels["vehicle.event_alert_type." + item.data.alarmType]
											? self.settings.commonLabels["vehicle.event_alert_type." + item.data.alarmType]
											: item.data.alarmType) +
									  "</span><br/>" +
									  '<span class="gray-color">POI:</span> <span class="lightGrey">' +
									  item.alarm_poi_display_name +
									  "</span><br/><br/>"
									: ""
							} 
						  <span class="gray-color">${item.position_display_name ? item.position_display_name + "</span><br/>" : ""}
						  <span><span class="blackColor">LAT:</span> <span class="lightGrey">${item.position.lat}</span> - <span class="blackColor">LON:</span> <span class="lightGrey">${
						item.position.lon
					}</span></span><br/><br/>
						  <span><span class="blackColor">Velocità:</span> <span class="lightGrey">${item.speed} km/h</span></span><br/>
						  <span><span class="blackColor">Direzione:</span> <span class="lightGrey">${self.DirectionDegreeTocardinal(item.drive_direction)}</span></span><br/>`;
					m.icon = {
						url: `/assets/alarms/icon/${item.type}-${item.subtype}.png`, // url
						scaledSize: new google.maps.Size(30, 48), // scaled size
						origin: new google.maps.Point(0, 0) // origin
					};
					m.infoWindowOptions.content = m.info;

					//manage same position
					var markersSamePosition = self.markers.filter(function(mm) {
						return mm.id != m.id && mm.position && mm.position.lat == m.position.lat && mm.position.lng == m.position.lng;
					});

					if (markersSamePosition.length > 0) {
						var maxIndexOfLoop = self._.maxBy(markersSamePosition, "infoWindowOptions.indexLoopSamePosition");
						if (maxIndexOfLoop) {
							m.infoWindowOptions.indexLoopSamePosition = maxIndexOfLoop.infoWindowOptions.indexLoopSamePosition + 1;
						}
					}
				}
			});

			if (self.data.length > 0) {
				setTimeout(function() {
					self.fitAndZoom();
				}, 1);
				//self.fitAndZoom();
			}
		},

		DirectionDegreeTocardinal(deg) {
			if (deg > 11.25 && deg < 33.75) {
				return "N-NE";
			} else if (deg > 33.75 && deg < 56.25) {
				return "NE";
			} else if (deg > 56.25 && deg < 78.75) {
				return "E-NE";
			} else if (deg > 78.75 && deg < 101.25) {
				return "E";
			} else if (deg > 101.25 && deg < 123.75) {
				return "E-SE";
			} else if (deg > 123.75 && deg < 146.25) {
				return "SE";
			} else if (deg > 146.25 && deg < 168.75) {
				return "S-SE";
			} else if (deg > 168.75 && deg < 191.25) {
				return "S";
			} else if (deg > 191.25 && deg < 213.75) {
				return "S-SO";
			} else if (deg > 213.75 && deg < 236.25) {
				return "SO";
			} else if (deg > 236.25 && deg < 258.75) {
				return "O-SO";
			} else if (deg > 258.75 && deg < 281.25) {
				return "O";
			} else if (deg > 281.25 && deg < 303.75) {
				return "O-NO";
			} else if (deg > 303.75 && deg < 326.25) {
				return "NO";
			} else if (deg > 326.25 && deg < 348.75) {
				return "N-NO";
			} else {
				return "N";
			}
		},
		setCustomZoom(value) {
			var self = this;
			if (self.$refs.alarmmap) {
				self.$refs.alarmmap.$mapPromise.then(map => {
					map.setZoom(value);
				});
			}
		},
		fitAndZoom: function(bnds) {
			var self = this;

			var bounds = new google.maps.LatLngBounds();

			if (bnds) {
				bounds = bnds;
			} else {
				self.markers.forEach(function(item, index) {
					bounds.extend(item.position);
				});
			}

			if (self.markers.length > 0 && bounds.equals(self.historyBounds) == false) {
				if (self.$refs.alarmmap) {
					self.$refs.alarmmap.$mapPromise.then(map => {
						map.fitBounds(bounds);
						if (map.getZoom() >= 22) {
							map.setZoom(14);
						}
					});

					self.historyBounds = bounds;
				}
			}
		},
		markerClick: function(marker, idx) {
			helpers.deleteTooltip();

			if (this.markers.length > 1 && marker.infoWindowOptions && marker.infoWindowOptions.infoWindowOpened) {
				//if is already open, search for other markers that have same coordinates
				var markersSamePosition = this.markers.filter(function(item) {
					return item.id != marker.id && item.position && item.position.lat == marker.position.lat && item.position.lng == marker.position.lng;
				});

				if (markersSamePosition.length > 0) {
					var lastIndex = marker.infoWindowOptions.indexLoopSamePosition;
					var mToShow = markersSamePosition.find(function(item) {
						return item.infoWindowOptions.indexLoopSamePosition > lastIndex;
					});

					if (mToShow) {
						marker = mToShow;
					} else {
						marker = markersSamePosition[0];
					}
				}
			}

			this.$emit("onMarkerClick", { marker, idx });

			this.hideAllInfoWindow();

			this.toggleInfoWindow(marker);
		},
		clusterClick(e) {
			var bounds = e.getBounds();
		},
		hideAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			//POI
			self.poiMarkers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiPaths.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiAreas.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});
		},
		showAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = true;
			});
		},
		centerMap: function(position) {
			var self = this;

			if (self.$refs.alarmmap) {
				self.$refs.alarmmap.$mapPromise.then(map => {
					map.setCenter(position);
				});
			}
		},
		toggleInfoWindow: function(marker, idx) {
			marker.infoWindowOptions.infoWindowOpened = !marker.infoWindowOptions.infoWindowOpened;
			this.markers.forEach(function(item, index) {
				item.zIndex = 0;
				if (item.id == marker.id) {
					item.zIndex = 1;
				}
			});

			// this.infoWindowPos = marker.position;
			// this.infoContent = marker.info;
			// this.infoOptions.content = marker.info;
			// //check if its the same marker that was selected if yes toggle
			// if (this.currentMidx == idx) {
			// 	this.infoWinOpen = !this.infoWinOpen;
			// }
			// //if different marker set infowindow to open and reset current marker index
			// else {
			// 	this.infoWinOpen = true;
			// 	this.currentMidx = idx;
			// }
		}
	},
	computed: {
		...mapGetters(["settings"])
	}
};
